const r = [
  "3d-3d-axis",
  "3d-cloth",
  "3d-cube",
  "3d-dolly",
  "3d-emissive",
  "3d-explode",
  "3d-instance",
  "3d-light-rect",
  "3d-light-rotate",
  "3d-material",
  "3d-move-global",
  "3d-reference",
  "3d-rotate-3d",
  "3d-rotate-global",
  "3d-segment",
  "3d-shader",
  "3d-shader-ball",
  "3d-skeleton",
  "3d-teapot",
  "3d-teleport",
  "3d-texture",
  "av-auto-record",
  "av-auto-record-off",
  "av-broadcast",
  "av-camera",
  "av-camera-add",
  "av-camera-off",
  "av-clap-board",
  "av-display-surround",
  "av-eject",
  "av-equalizer",
  "av-faders",
  "av-fast-forward",
  "av-fast-reverse",
  "av-film",
  "av-film-add",
  "av-film-collection",
  "av-forward-10",
  "av-fps",
  "av-high-quality",
  "av-hud",
  "av-loop",
  "av-loop-off",
  "av-microphone",
  "av-microphone-off",
  "av-next",
  "av-notes",
  "av-pause",
  "av-picture-in-picture",
  "av-play",
  "av-previous",
  "av-record",
  "av-replay",
  "av-replay-off",
  "av-reverse-10",
  "av-soundwaves",
  "av-speaker",
  "av-speaker-high",
  "av-speaker-low",
  "av-speaker-medium",
  "av-speaker-mute",
  "av-speaker-off",
  "av-step-forward",
  "av-step-reverse",
  "av-stop",
  "av-videocam",
  "av-videocam-off",
  "av-watch-party",
  "common-add",
  "common-add-circle",
  "common-alarm",
  "common-bell",
  "common-bell-off",
  "common-calendar",
  "common-calendar-event",
  "common-cancel",
  "common-check",
  "common-check-circle",
  "common-check-multi-circle",
  "common-clipboard",
  "common-clock",
  "common-close",
  "common-close-circle",
  "common-cog",
  "common-cog-off",
  "common-copy-doc",
  "common-copy-generic",
  "common-enter",
  "common-error",
  "common-exit",
  "common-eye",
  "common-eye-off",
  "common-filter",
  "common-help-circle",
  "common-history",
  "common-home",
  "common-home-off",
  "common-info-circle",
  "common-link",
  "common-link-break",
  "common-lock-closed",
  "common-lock-open",
  "common-magnifying-glass",
  "common-magnifying-glass-minus",
  "common-magnifying-glass-plus",
  "common-menu",
  "common-more-horiz",
  "common-more-vert",
  "common-paperplane",
  "common-redo",
  "common-refresh",
  "common-reset",
  "common-retry",
  "common-share",
  "common-sort",
  "common-star",
  "common-subtract",
  "common-subtract-circle",
  "common-sync",
  "common-sync-off",
  "common-timer",
  "common-trash",
  "common-undo",
  "common-warning",
  "communication-cloud",
  "communication-cloud-off",
  "communication-data",
  "communication-download",
  "communication-envelope",
  "communication-envelope-off",
  "communication-firewall",
  "communication-firewall-off",
  "communication-forward",
  "communication-isp",
  "communication-isp-off",
  "communication-network-signal",
  "communication-network-signal-off",
  "communication-reply",
  "communication-sync-warning",
  "communication-transfer-horizontal",
  "communication-transfer-vertical",
  "communication-upload",
  "communication-wifi",
  "communication-wifi-off",
  "cursor-arrow",
  "cursor-crosshair",
  "cursor-hand-closed",
  "cursor-hand-open",
  "cursor-hand-pinch",
  "cursor-hand-point",
  "cursor-hourglass",
  "cursor-hourglass-end",
  "cursor-hourglass-mid",
  "cursor-hourglass-start",
  "editor-anchor-center",
  "editor-anchor-e",
  "editor-anchor-n",
  "editor-anchor-ne",
  "editor-anchor-nw",
  "editor-anchor-s",
  "editor-anchor-se",
  "editor-anchor-sw",
  "editor-anchor-w",
  "editor-at-symbol",
  "editor-backspace",
  "editor-bold",
  "editor-branch",
  "editor-chart",
  "editor-chart-bar",
  "editor-chart-flow",
  "editor-chart-hierarchy",
  "editor-chart-performance",
  "editor-chart-pie",
  "editor-chart-tree",
  "editor-collapse",
  "editor-commit",
  "editor-compare",
  "editor-connection",
  "editor-expand",
  "editor-export-to-clipboard",
  "editor-fit",
  "editor-fork",
  "editor-freehand",
  "editor-grid",
  "editor-grid-off",
  "editor-h-align-center",
  "editor-h-align-left",
  "editor-h-align-right",
  "editor-header",
  "editor-image",
  "editor-italic",
  "editor-iterate",
  "editor-keyframe",
  "editor-layers",
  "editor-layers-off",
  "editor-line-segment",
  "editor-list-bullet",
  "editor-list-checkmark",
  "editor-list-number",
  "editor-markdown",
  "editor-merge",
  "editor-move",
  "editor-numbers",
  "editor-paperclip",
  "editor-paragraph",
  "editor-pencil",
  "editor-pull",
  "editor-pull-close",
  "editor-pull-draft",
  "editor-rotate",
  "editor-rotate-90-clockwise",
  "editor-rotate-90-counter",
  "editor-ruler",
  "editor-scale-down",
  "editor-scale-reset",
  "editor-scale-up",
  "editor-scissors",
  "editor-section",
  "editor-section-bottom",
  "editor-section-top",
  "editor-select-brush",
  "editor-signature",
  "editor-skip",
  "editor-sliders",
  "editor-sort-ascending",
  "editor-sort-descending",
  "editor-sticker",
  "editor-sticker-image",
  "editor-sticker-shape",
  "editor-sticker-text",
  "editor-sticker-zoom",
  "editor-strikethrough",
  "editor-stroke-width",
  "editor-style",
  "editor-swatches",
  "editor-text",
  "editor-text-align-center",
  "editor-text-align-full",
  "editor-text-align-left",
  "editor-text-align-right",
  "editor-text-framed",
  "editor-trash-delete",
  "editor-typography",
  "editor-underline",
  "editor-v-align-bottom",
  "editor-v-align-center",
  "editor-v-align-top",
  "editor-wand",
  "editor-wrench",
  "files-archive",
  "files-db",
  "files-document",
  "files-document-checkmark",
  "files-document-new",
  "files-document-preview",
  "files-export",
  "files-floppy",
  "files-folder-closed",
  "files-folder-open",
  "files-import",
  "hardware-2-b-left-click",
  "hardware-battery-0",
  "hardware-battery-0-off",
  "hardware-battery-100",
  "hardware-battery-25",
  "hardware-battery-50",
  "hardware-battery-75",
  "hardware-battery-boost",
  "hardware-battery-charging",
  "hardware-bluetooth",
  "hardware-bluetooth-off",
  "hardware-calculator",
  "hardware-cpu",
  "hardware-display",
  "hardware-display-collection",
  "hardware-display-off",
  "hardware-drive-cloud",
  "hardware-drive-cloud-off",
  "hardware-drive-network",
  "hardware-drive-network-off",
  "hardware-drive-removable",
  "hardware-drive-removable-off",
  "hardware-drive-usb",
  "hardware-drive-usb-off",
  "hardware-ethernet",
  "hardware-fan",
  "hardware-fan-loud",
  "hardware-fan-quiet",
  "hardware-gamepad",
  "hardware-gamepad-off",
  "hardware-gamepad-start",
  "hardware-gpu",
  "hardware-gpu-card",
  "hardware-gpu-card-multi",
  "hardware-gpu-card-off",
  "hardware-gpu-off",
  "hardware-headset",
  "hardware-keyboard",
  "hardware-laptop",
  "hardware-lightning",
  "hardware-mac",
  "hardware-mac-off",
  "hardware-media-optical",
  "hardware-mosaic",
  "hardware-mouse-2-b",
  "hardware-mouse-2-b-right-click",
  "hardware-mouse-3-b",
  "hardware-mouse-scrollwheel",
  "hardware-mouse-scrollwheel-active",
  "hardware-multidrive",
  "hardware-network",
  "hardware-network-connection",
  "hardware-network-pcs",
  "hardware-nvidia-shield",
  "hardware-nvidia-shield-stand",
  "hardware-performance-high",
  "hardware-performance-low",
  "hardware-performance-medium",
  "hardware-phone-laptop",
  "hardware-plug-recepticle",
  "hardware-plug-usb",
  "hardware-plugin",
  "hardware-power",
  "hardware-ram",
  "hardware-remote",
  "hardware-robot-arm",
  "hardware-sd-card",
  "hardware-smartphone",
  "hardware-smartphone-off",
  "hardware-tablet",
  "hardware-tablet-off",
  "hardware-telephone",
  "hardware-telephone-off",
  "hardware-usb",
  "hardware-vr",
  "hardware-watch",
  "hardware-webcam",
  "hardware-webcam-off",
  "hardware-webcam-settings",
  "hardware-whispermode",
  "hardware-wireless-modem",
  "hardware-wireless-modem-off",
  "hardware-workstation",
  "hardware-workstation-off",
  "hardware-workstation-system",
  "hardware-workstation-system-off",
  "image-brush",
  "image-bucket",
  "image-camera-360",
  "image-camera-linked",
  "image-camera-super",
  "image-collection",
  "image-crop",
  "image-denoise",
  "image-easel",
  "image-eraser",
  "image-eyedropper",
  "image-group",
  "image-import-image",
  "image-mask-inside",
  "image-mask-outside",
  "image-mirror",
  "image-outpainting",
  "image-palette",
  "image-scale",
  "image-scale-relative",
  "image-scale-relative-off",
  "image-select-ellipse",
  "image-select-polygon",
  "image-select-rectangle",
  "image-shapes",
  "image-sun-high",
  "image-sun-low",
  "image-sun-off-high",
  "image-transparency",
  "maps-airplane",
  "maps-briefcase",
  "maps-bush",
  "maps-business",
  "maps-dirt",
  "maps-elevator",
  "maps-escalator",
  "maps-factory",
  "maps-flag",
  "maps-flower",
  "maps-fog",
  "maps-grass",
  "maps-gravel",
  "maps-hill",
  "maps-location",
  "maps-location-off",
  "maps-map",
  "maps-map-off",
  "maps-mountain",
  "maps-mud",
  "maps-river",
  "maps-rock",
  "maps-sand",
  "maps-sea",
  "maps-signpost",
  "maps-sky",
  "maps-snow",
  "maps-stair",
  "maps-stone",
  "maps-straw",
  "maps-suitcase",
  "maps-toolbox",
  "maps-tree",
  "maps-trees",
  "maps-water",
  "maps-world",
  "maps-world-off",
  "misc-bandaid",
  "misc-beaker",
  "misc-blackboard",
  "misc-book",
  "misc-bug",
  "misc-bug-off",
  "misc-car",
  "misc-checkmark-badge",
  "misc-circle-1-q",
  "misc-circle-2-q",
  "misc-circle-3-q",
  "misc-circle-tick",
  "misc-code",
  "misc-compass",
  "misc-delivery-truck",
  "misc-ekg",
  "misc-function",
  "misc-gift",
  "misc-graduate",
  "misc-graph-node",
  "misc-graph-node-connect",
  "misc-graph-node-delete",
  "misc-health",
  "misc-hot-air-balloon",
  "misc-ime",
  "misc-infinity",
  "misc-key",
  "misc-library",
  "misc-library-games",
  "misc-lifebouy",
  "misc-lightbulb",
  "misc-magnet",
  "misc-man",
  "misc-man-woman",
  "misc-math",
  "misc-megaphone",
  "misc-microscope",
  "misc-mode-component",
  "misc-money",
  "misc-money-coin",
  "misc-money-paper",
  "misc-moon",
  "misc-moon-off",
  "misc-mug",
  "misc-neural-network",
  "misc-news",
  "misc-package",
  "misc-payment-card",
  "misc-pizza",
  "misc-prayer-room",
  "misc-projector",
  "misc-pulse",
  "misc-puzzle",
  "misc-qrcode",
  "misc-radar",
  "misc-radioactive",
  "misc-rocket",
  "misc-running",
  "misc-scale-balance",
  "misc-school",
  "misc-seed",
  "misc-sensor",
  "misc-shield",
  "misc-shield-off",
  "misc-ship-wheel",
  "misc-shopping-bag",
  "misc-shopping-basket",
  "misc-shopping-cart",
  "misc-shopping-cart-open",
  "misc-sparkle",
  "misc-tag",
  "misc-tag-label",
  "misc-telescope",
  "misc-thermometer",
  "misc-ticket",
  "misc-traffic-cone",
  "misc-weight",
  "misc-weight-bar",
  "misc-wheelchair",
  "misc-woman",
  "shapes-arrow-down",
  "shapes-arrow-down-left",
  "shapes-arrow-down-max",
  "shapes-arrow-down-right",
  "shapes-arrow-left",
  "shapes-arrow-left-max",
  "shapes-arrow-left-right",
  "shapes-arrow-right",
  "shapes-arrow-right-max",
  "shapes-arrow-up",
  "shapes-arrow-up-down",
  "shapes-arrow-up-left",
  "shapes-arrow-up-max",
  "shapes-arrow-up-right",
  "shapes-chevron-double-down",
  "shapes-chevron-double-left",
  "shapes-chevron-double-right",
  "shapes-chevron-double-up",
  "shapes-chevron-down",
  "shapes-chevron-down-left-up-right",
  "shapes-chevron-left",
  "shapes-chevron-left-right",
  "shapes-chevron-right",
  "shapes-chevron-up",
  "shapes-chevron-up-down",
  "shapes-chevron-up-left-down-right",
  "shapes-diamond",
  "shapes-diamond-off",
  "shapes-return",
  "shapes-shape-circle",
  "shapes-shape-circle-off",
  "shapes-shape-hexagon",
  "shapes-shape-octogon",
  "shapes-shape-square",
  "shapes-shape-square-off",
  "shapes-shape-triangle",
  "social-account-add",
  "social-account-check",
  "social-account-more",
  "social-account-remove",
  "social-award-ribbon",
  "social-award-trophy",
  "social-baby",
  "social-bookmark",
  "social-bookmark-off",
  "social-chat-message",
  "social-chat-multi",
  "social-chat-new",
  "social-chat-single",
  "social-chatbot",
  "social-feeling-happy",
  "social-feeling-neutral",
  "social-feeling-sad",
  "social-feeling-very-happy",
  "social-feeling-very-sad",
  "social-founders",
  "social-founders-tier-1",
  "social-founders-tier-2",
  "social-founders-tier-3",
  "social-heart",
  "social-heart-off",
  "social-identification",
  "social-license",
  "social-pin",
  "social-pin-off",
  "social-profile",
  "social-profile-group",
  "social-profile-off",
  "social-ranking-xp",
  "social-thumb-down",
  "social-thumb-up",
  "view-3-square-plus",
  "view-4-square",
  "view-apps",
  "view-carousel-horizontal",
  "view-carousel-vertical",
  "view-display-share",
  "view-dual",
  "view-feedback",
  "view-fit-to-page",
  "view-fullscreen",
  "view-fullscreen-exit",
  "view-gallery-strip",
  "view-grip-area",
  "view-grip-corner",
  "view-grip-edge-horizontal",
  "view-grip-edge-vertical",
  "view-grip-mini",
  "view-layout-columns",
  "view-layout-detail",
  "view-layout-grid",
  "view-layout-list",
  "view-layout-rows",
  "view-map",
  "view-open-external",
  "view-pill-bar-stack",
  "view-rectangle-group",
  "view-render",
  "view-stack-horizontal",
  "view-window",
  "view-window-code",
  "view-window-grid",
  "view-window-stack",
  "view-window-terminal",
  "view-workspace",
  "view-workspace-group"
];
function s(e) {
  return !!r.find((a) => a === e);
}
function n(e) {
  return e.split("-")[1];
}
function c(e) {
  return e.split("-")[0];
}
const l = [
  "6",
  "8",
  "access",
  "accessibility",
  "account",
  "accounts",
  "achievement",
  "acorn",
  "action",
  "actions",
  "activity",
  "ada",
  "add",
  "addition",
  "additional",
  "address",
  "adjust",
  "advance",
  "affect",
  "aft",
  "after",
  "again",
  "against",
  "age",
  "ai",
  "aid",
  "aim",
  "air",
  "alarm",
  "alert",
  "algorithm",
  "all",
  "all up",
  "amount",
  "amplify",
  "amplitude",
  "android",
  "angle brackets",
  "animation",
  "announce",
  "answer",
  "answers",
  "anti",
  "appearance",
  "apple",
  "application",
  "applications",
  "approve",
  "approved",
  "apps",
  "archive",
  "area",
  "areas",
  "arrange",
  "array",
  "arrow",
  "arrows",
  "art",
  "artboard",
  "articles",
  "articulation",
  "artificial intelligence",
  "aspect ratio",
  "astronomy",
  "attached",
  "attachment",
  "attempt",
  "attention",
  "attraction",
  "audio",
  "authentication",
  "autograph",
  "automatic",
  "automation",
  "automobile",
  "av",
  "avatar",
  "avatars",
  "avoid",
  "award",
  "back",
  "background",
  "backup",
  "backward",
  "backwards",
  "bad",
  "badge",
  "bag",
  "baggage",
  "balanced",
  "bar",
  "barbell",
  "barrier",
  "bars",
  "base",
  "basic",
  "bee",
  "before",
  "begin",
  "beginning",
  "bell",
  "benchmark",
  "bernoulli",
  "beverage",
  "big",
  "bigger",
  "bill",
  "billboard",
  "bin",
  "binary",
  "birds",
  "bit",
  "bits",
  "block",
  "blocked",
  "blocker",
  "blocks",
  "boat",
  "body",
  "boil",
  "bones",
  "books",
  "boot",
  "border",
  "bottom",
  "boulder",
  "boundary",
  "bounds",
  "bow",
  "box",
  "branches",
  "break",
  "bridge",
  "bright",
  "broadcast",
  "broken",
  "browse",
  "browser",
  "build",
  "building",
  "bulb",
  "bulk",
  "bullhorn",
  "bundle",
  "burger",
  "burst",
  "business",
  "busy",
  "buttons",
  "buy",
  "buzzer",
  "cable",
  "cactus",
  "call",
  "camera",
  "can",
  "cancel",
  "canvas",
  "capacity",
  "capsule",
  "capture",
  "card",
  "cards",
  "care",
  "cargo",
  "carriage",
  "categories",
  "categorize",
  "caution",
  "cave",
  "cd",
  "cells",
  "central processing unit",
  "certificate",
  "chain",
  "chalk",
  "change",
  "channel",
  "chapel",
  "character",
  "characters",
  "charged",
  "chat",
  "check",
  "checkin",
  "checkout",
  "child",
  "chip",
  "choose",
  "circle",
  "circuit",
  "city",
  "clapper",
  "clarify",
  "classic",
  "classroom",
  "cli",
  "click",
  "clip",
  "clips",
  "clock",
  "clone",
  "close",
  "clothes",
  "clothing",
  "cluster",
  "code",
  "coffee",
  "coin",
  "cold",
  "collaboration",
  "collapse",
  "colleagues",
  "collection",
  "college",
  "color",
  "colorful",
  "coloring",
  "colors",
  "combined displays",
  "combo",
  "command line interface",
  "commerce",
  "communications",
  "community",
  "compare",
  "complex",
  "component",
  "components",
  "compute",
  "computed",
  "computer",
  "computers",
  "config",
  "configuration",
  "confirm",
  "confirmed",
  "conform",
  "connect",
  "connected",
  "connection",
  "connections",
  "connector",
  "connectors",
  "console",
  "construction",
  "container",
  "containers",
  "content",
  "contents",
  "contextual",
  "continuous",
  "control",
  "controller",
  "controls",
  "conversation",
  "convert",
  "copy",
  "corner",
  "corners",
  "count",
  "couple",
  "cover",
  "coworkers",
  "crash",
  "create",
  "credit",
  "crescent",
  "critical",
  "cross",
  "crosshair",
  "crunch",
  "crystal",
  "cuisine",
  "cup",
  "currency",
  "cursor",
  "custom",
  "customize",
  "cut",
  "cycle",
  "cycles",
  "danger",
  "dark",
  "dashboard",
  "data",
  "data center",
  "data entry",
  "data viz",
  "database",
  "date",
  "day",
  "debit",
  "dedicated",
  "deep",
  "delay",
  "delete",
  "demo",
  "desert",
  "desktop",
  "details",
  "developer",
  "development",
  "device",
  "dexterity",
  "diagonal",
  "diagram",
  "dialogue",
  "dictate",
  "diff",
  "digits",
  "dim",
  "dimensions",
  "direct",
  "direction",
  "directions",
  "directory",
  "dirt",
  "disable",
  "disabled",
  "disapprove",
  "disc",
  "discover",
  "discreet",
  "discs",
  "dish",
  "disk",
  "dislike",
  "dismiss",
  "displace",
  "display",
  "distance",
  "distribute",
  "divide",
  "divided",
  "dl",
  "doctor",
  "document",
  "documentation",
  "documents",
  "dollar",
  "done",
  "dot",
  "dots",
  "double",
  "down",
  "down arrow",
  "dpad",
  "draft",
  "drag",
  "drape",
  "draw",
  "drawer",
  "drawing",
  "drink",
  "drive",
  "drivers",
  "driving",
  "drop",
  "dry",
  "dry erase",
  "dunes",
  "duplicate",
  "dvd",
  "earth",
  "east",
  "eclipse",
  "edge",
  "edges",
  "edit",
  "education",
  "eight",
  "electricity",
  "electromagnetism",
  "electronics",
  "elevation",
  "ellipses",
  "ellipsis",
  "email",
  "embed",
  "emergency",
  "emit",
  "emotion",
  "emphasis",
  "empty",
  "enable",
  "encode",
  "end",
  "energy",
  "enlarge",
  "enter",
  "entry",
  "environment",
  "eq",
  "error",
  "escape",
  "ethernet",
  "even",
  "evening",
  "event",
  "events",
  "example",
  "exchange",
  "exercise",
  "exit",
  "expand",
  "expansion",
  "experience",
  "experiment",
  "expire",
  "explore",
  "extend",
  "exterior",
  "extra",
  "eye",
  "eyeball",
  "fabric",
  "face",
  "faces",
  "fail",
  "failure",
  "fan",
  "faq",
  "father",
  "favorite",
  "feature",
  "feedback",
  "female",
  "figure",
  "file",
  "files",
  "fill",
  "filled",
  "final",
  "finance",
  "find",
  "finish",
  "finished",
  "fit",
  "fix",
  "flag",
  "flake",
  "flash",
  "flight",
  "float",
  "flood",
  "floors",
  "floppy",
  "flow",
  "flush",
  "fly",
  "flying",
  "fold",
  "folded",
  "font",
  "food",
  "force",
  "forest",
  "form",
  "format",
  "forward",
  "four",
  "fraction",
  "frame",
  "frames",
  "frames per second",
  "frank",
  "freestyle",
  "freight",
  "frequencies",
  "frequency",
  "friends",
  "full",
  "funnel",
  "fyi",
  "gadget",
  "garbage",
  "garbage can",
  "gather",
  "gauge",
  "gear",
  "generic",
  "geography",
  "gesture",
  "get",
  "get out",
  "git",
  "give",
  "glass",
  "global",
  "globe",
  "go",
  "goal",
  "goggles",
  "good",
  "grab",
  "graph",
  "graphic",
  "graphics processing unit",
  "grassland",
  "green",
  "grid",
  "ground",
  "group",
  "grouping",
  "groups",
  "grove",
  "grow",
  "guard",
  "guidance",
  "guidelines",
  "half",
  "hamburger",
  "handicap",
  "hands",
  "handset",
  "hang",
  "hanger",
  "happened",
  "hard drives",
  "hardware",
  "hat",
  "hdd",
  "headline",
  "headlines",
  "headphones",
  "heads up display",
  "health",
  "healthy",
  "heart",
  "heartbeat",
  "heavy",
  "help",
  "hertz",
  "hewn",
  "hexagonal",
  "hidden",
  "hide",
  "hierarchy",
  "high",
  "high point",
  "high power",
  "hike",
  "histogram",
  "hold",
  "honeycomb",
  "honor",
  "hook",
  "horizon",
  "horizontal",
  "hospital",
  "hot",
  "hot chocolate",
  "hotspot",
  "house",
  "hub",
  "hybrid",
  "hyperlink",
  "ide",
  "idea",
  "identification",
  "identity",
  "ignore",
  "illumination",
  "imac",
  "image",
  "images",
  "importance",
  "improve",
  "incident",
  "increase",
  "index finger",
  "indicator",
  "individual",
  "industry",
  "information",
  "input",
  "insert",
  "inset",
  "inspect",
  "installer",
  "instance",
  "instant",
  "integrated development environment",
  "intensity",
  "interior",
  "internet",
  "invisibility",
  "invisible",
  "ios",
  "ipad",
  "iphone",
  "iq",
  "irregular",
  "issue",
  "italian",
  "items",
  "iterations",
  "jet",
  "job",
  "joints",
  "juice",
  "jump",
  "justified",
  "keep",
  "key",
  "keyhole",
  "keynote",
  "keys",
  "keystroke",
  "kid",
  "kindle",
  "lab",
  "label",
  "lake",
  "lan",
  "landmark",
  "landscape",
  "language",
  "larger",
  "lattice",
  "launch",
  "launcher",
  "lda",
  "leaf",
  "learn",
  "learning",
  "leave",
  "leaves",
  "left",
  "legal",
  "legibility",
  "lens",
  "letters",
  "level",
  "levels",
  "library",
  "lift",
  "light",
  "lighting",
  "like",
  "likeness",
  "limbs",
  "line",
  "lines",
  "link",
  "liquid",
  "list",
  "live",
  "llm",
  "local area",
  "local area network",
  "location",
  "lock",
  "locked",
  "login",
  "look",
  "loop",
  "loud",
  "loudspeaker",
  "low",
  "low clouds",
  "low power",
  "lower",
  "machine",
  "macintosh",
  "magic",
  "magnetism",
  "magnifier",
  "magnify",
  "mail",
  "main",
  "maintain",
  "male",
  "malware",
  "manual",
  "manufacture",
  "mark",
  "marker",
  "marquee",
  "mask",
  "mass",
  "material",
  "materials",
  "math",
  "max",
  "maximize",
  "measure",
  "measurement",
  "measures",
  "mechanical",
  "media",
  "medical",
  "meditation",
  "medium",
  "meeting",
  "meetings",
  "melody",
  "memory",
  "men",
  "menu",
  "message",
  "method",
  "micro",
  "microphone",
  "middle",
  "mids",
  "migrate",
  "min",
  "mini",
  "minimize",
  "minus",
  "mist",
  "ml",
  "mobile",
  "modify",
  "modules",
  "money",
  "monitor",
  "month",
  "more",
  "mosaic",
  "mother",
  "motherboard",
  "motion",
  "mount",
  "mouse",
  "move",
  "movement",
  "movie",
  "movies",
  "moving",
  "multimon",
  "multiple",
  "multiply",
  "music",
  "mute",
  "mystery",
  "name",
  "natural",
  "nav",
  "navigate",
  "navigation",
  "negative",
  "network",
  "networking",
  "neutral",
  "neverending",
  "new",
  "new line",
  "news",
  "next",
  "night",
  "no alarm",
  "no camera",
  "no connection",
  "no email",
  "no enlarge",
  "no eye",
  "no feature",
  "no gear",
  "no guidelines",
  "no network",
  "no networking",
  "no order",
  "no origin",
  "no picture",
  "no repeat",
  "no shape",
  "no simple",
  "no start",
  "no thumbtack",
  "no user",
  "no voice",
  "no weather",
  "node",
  "nodes",
  "noise",
  "normal",
  "north",
  "northeast",
  "northwest",
  "notation",
  "note",
  "notebook",
  "notes",
  "notification",
  "nuclear",
  "numbers",
  "numeric",
  "nurse",
  "object",
  "objects",
  "oblique",
  "occupation",
  "ocean",
  "office",
  "official",
  "ok",
  "old",
  "on top",
  "one",
  "onion",
  "online",
  "opacity",
  "open",
  "open water",
  "opinion",
  "optical",
  "optics",
  "options",
  "order",
  "ordered",
  "organic",
  "origin",
  "original",
  "output",
  "outside",
  "over",
  "overlay",
  "package",
  "padlock",
  "page",
  "pages",
  "paint",
  "painting",
  "pair",
  "pan",
  "panels",
  "panorama",
  "panoramic",
  "paper",
  "parents",
  "parking",
  "part",
  "particles",
  "parts",
  "pass",
  "pass along",
  "passenger",
  "passes",
  "password",
  "past",
  "paste",
  "pasture",
  "patch",
  "patch cable",
  "path",
  "pathfinding",
  "pattern",
  "pause",
  "pc",
  "pci",
  "peak",
  "pebbles",
  "pencil",
  "people",
  "perforations",
  "performance",
  "period",
  "periodical",
  "peripheral",
  "permanent",
  "person",
  "personal",
  "petals",
  "photo",
  "photography",
  "photos",
  "pick",
  "picker",
  "pickup",
  "picture",
  "pie",
  "piece",
  "pieces",
  "pile",
  "pin",
  "ping",
  "pivot",
  "place",
  "planet",
  "planets",
  "plant",
  "plants",
  "playback",
  "plugged in",
  "plus",
  "point",
  "pointer",
  "points",
  "poof",
  "poor",
  "port",
  "portable",
  "portfolio",
  "portion",
  "position",
  "positive",
  "pound",
  "power",
  "preferences",
  "present",
  "presentation",
  "press",
  "preview",
  "previous",
  "price",
  "primitive",
  "primitives",
  "print",
  "prior",
  "privacy",
  "private",
  "prize",
  "problem",
  "process",
  "processor",
  "production",
  "prongs",
  "proof",
  "properties",
  "protection",
  "proxy",
  "public address",
  "pull",
  "pulse",
  "purchase",
  "push",
  "put",
  "quadrants",
  "query",
  "question",
  "quick redirect",
  "quiet",
  "race",
  "ragged",
  "raid",
  "ramp",
  "random access memory",
  "randomization",
  "range",
  "rank",
  "rate",
  "rating",
  "rays",
  "react",
  "read",
  "readability",
  "recall",
  "recant",
  "receive",
  "receiver",
  "reception",
  "receptor",
  "recipient",
  "record",
  "recording",
  "records",
  "rectangular",
  "recurring",
  "recycle",
  "redact",
  "redeem",
  "reduce",
  "reel",
  "refine",
  "reflect",
  "reflection",
  "refresh",
  "refresh rate",
  "region",
  "regions",
  "reject",
  "religion",
  "relocate",
  "remember",
  "reminder",
  "remove",
  "render",
  "repair",
  "repeat",
  "repeats",
  "replay",
  "replenish",
  "replies",
  "reply",
  "resize",
  "resolution",
  "response",
  "restore",
  "restrooms",
  "reticle",
  "return",
  "reverse",
  "revert",
  "reward",
  "rewind",
  "right",
  "ring",
  "rise",
  "river bank",
  "rock",
  "rocks",
  "rocky",
  "roll",
  "rolling",
  "romance",
  "rotate",
  "rough",
  "roughness",
  "round",
  "router",
  "row",
  "rubbish",
  "rule",
  "safe",
  "safety",
  "same",
  "sampler",
  "sash",
  "satisfaction",
  "save",
  "savings",
  "scan",
  "scene",
  "schedule",
  "school",
  "science",
  "screen",
  "scribble",
  "scrub",
  "search",
  "sections",
  "secure",
  "security",
  "see through",
  "segment",
  "segmentation",
  "segments",
  "select",
  "send",
  "send back",
  "sensor",
  "separate",
  "sequence",
  "server",
  "session",
  "set",
  "set top box",
  "sets",
  "settings",
  "setup",
  "shadowplay",
  "share",
  "sheet",
  "shelf",
  "shield",
  "shift",
  "shiny",
  "shipment",
  "shop",
  "short",
  "shorthand",
  "show",
  "showcase",
  "shrink",
  "shrubbery",
  "shutdown",
  "shuttle",
  "side",
  "sides",
  "sideways",
  "sight",
  "sign",
  "signal",
  "signals",
  "signin",
  "silent",
  "simple",
  "simplify",
  "simulation",
  "single",
  "singular",
  "six",
  "size",
  "skill",
  "skin",
  "skip",
  "skyscraper",
  "slant",
  "slash",
  "slate",
  "sli",
  "slice",
  "sliders",
  "slow",
  "small",
  "smaller",
  "smart",
  "smooth",
  "snapshot",
  "social",
  "socket",
  "soil",
  "solo",
  "solution",
  "solve",
  "sonar",
  "sort",
  "sound",
  "soundboard",
  "soupy",
  "source",
  "south",
  "southeast",
  "southwest",
  "space",
  "speaker",
  "special",
  "speech bubble",
  "speech bubbles",
  "speed",
  "spin",
  "spinner",
  "split",
  "spring",
  "sql",
  "square",
  "stack",
  "staircase",
  "stairs",
  "stairwell",
  "stalks",
  "stand",
  "standard",
  "star",
  "stars",
  "start",
  "start over",
  "state",
  "statistic",
  "stb",
  "steam",
  "steer",
  "stems",
  "steps",
  "sticky",
  "still",
  "stones",
  "stop",
  "stop repeating",
  "stop watch",
  "stopped",
  "storage",
  "store",
  "straight",
  "straightedge",
  "streaming",
  "stretch",
  "strip",
  "stripe",
  "strips",
  "stroke",
  "strokes",
  "strong",
  "structure",
  "students",
  "study",
  "style",
  "styles",
  "stylus",
  "sub",
  "subtract",
  "success",
  "summary",
  "sunset",
  "superimpose",
  "support",
  "surface",
  "surprise",
  "surround",
  "swipe",
  "switch",
  "swivel",
  "symbol",
  "sync",
  "syntax",
  "tabloid",
  "tactile",
  "tag",
  "tags",
  "tall",
  "tap",
  "target",
  "tasks",
  "tassle",
  "taxonomy",
  "tea",
  "teachers",
  "team",
  "television",
  "temperature",
  "template",
  "temporary",
  "tender",
  "terminal",
  "test",
  "text",
  "textures",
  "thickness",
  "thought",
  "three",
  "threshold",
  "thumbnails",
  "thumbtack",
  "tick",
  "tie",
  "tile",
  "tiled",
  "time",
  "time series",
  "timing",
  "tip",
  "title",
  "tix",
  "to",
  "to do",
  "together",
  "tool",
  "top",
  "toppings",
  "total",
  "touch",
  "tower",
  "track",
  "translate",
  "translation",
  "translucency",
  "transmit",
  "transport",
  "travel",
  "treble",
  "trend",
  "trial",
  "triangle",
  "trim",
  "trunk",
  "try again",
  "turn",
  "tv",
  "tween",
  "twinkle",
  "twirl",
  "type",
  "types",
  "under",
  "undo",
  "unique",
  "universal",
  "university",
  "unlimited",
  "unlocked",
  "unmount",
  "unordered",
  "up",
  "up arrow",
  "update",
  "upper",
  "url",
  "user",
  "users",
  "utilities",
  "valid",
  "validate",
  "validated",
  "validation",
  "values",
  "vehicle",
  "vellum",
  "version",
  "vertical",
  "vial",
  "video",
  "video chat",
  "video games",
  "videos",
  "view",
  "virtual",
  "virtual reality",
  "virus",
  "visibility",
  "visible",
  "visual",
  "visualization",
  "visuals",
  "voice",
  "volume",
  "volumes",
  "vr",
  "wait",
  "waiting",
  "wake",
  "wall",
  "wallet",
  "wan",
  "wap",
  "warm",
  "warning",
  "waste",
  "watch",
  "water",
  "wave",
  "wavelength",
  "waves",
  "waypoint",
  "wearable",
  "weather",
  "web",
  "week",
  "weights",
  "west",
  "wet",
  "wheel",
  "whimsical",
  "whole",
  "whoosh",
  "wide area network",
  "widgets",
  "wifi",
  "wild",
  "win",
  "window",
  "wired",
  "wireless",
  "wizard",
  "women",
  "woods",
  "words",
  "work",
  "work out",
  "workflow",
  "working",
  "wormhole",
  "wrap around",
  "wrapped",
  "wrist",
  "write",
  "www",
  "wysiwyg",
  "year",
  "young",
  "zip",
  "zoom",
  "zoom in",
  "zoom out"
], d = {
  "3d-3d-axis": ["dimensions", "directions", "guidelines", "rays"],
  "3d-cloth": ["clothing", "drape", "hang", "hanger", "materials", "type"],
  "3d-cube": ["bounds", "box", "container", "frame", "primitive", "square"],
  "3d-dolly": ["aft", "backward", "forward", "move"],
  "3d-emissive": ["emit", "send"],
  "3d-explode": ["divide", "faces", "parts", "pieces", "separate"],
  "3d-instance": [
    "clone",
    "copy",
    "image",
    "likeness",
    "reflection",
    "same",
    "virtual"
  ],
  "3d-light-rect": ["illumination", "square"],
  "3d-light-rotate": ["bulb", "spin"],
  "3d-material": ["lighting", "reflection", "render", "surface"],
  "3d-move-global": [
    "adjust",
    "arrows",
    "change",
    "cross",
    "object",
    "relocate"
  ],
  "3d-reference": ["image", "likeness", "pointer", "proxy", "same"],
  "3d-rotate-3d": [
    "arrows",
    "circle",
    "dimensions",
    "pivot",
    "roll",
    "spin",
    "swivel",
    "twirl"
  ],
  "3d-rotate-global": ["object", "spin"],
  "3d-segment": [
    "bit",
    "divide",
    "object",
    "part",
    "piece",
    "portion",
    "separate",
    "split"
  ],
  "3d-shader": [
    "algorithm",
    "computed",
    "lighting",
    "look",
    "materials",
    "render"
  ],
  "3d-shader-ball": [
    "demo",
    "example",
    "lighting",
    "materials",
    "object",
    "showcase",
    "textures"
  ],
  "3d-skeleton": ["bones", "joints", "limbs", "parts", "pieces", "segments"],
  "3d-teapot": ["beverage", "boil", "cup", "example", "hot"],
  "3d-teleport": ["translation", "transport", "travel", "wormhole"],
  "3d-texture": ["material", "render", "roughness", "surface"],
  "av-auto-record": [],
  "av-auto-record-off": ["movies", "no feature", "shadowplay", "videos"],
  "av-broadcast": ["send", "signal", "tower", "waves"],
  "av-camera": ["body", "image", "lens", "photography", "picture", "snapshot"],
  "av-camera-add": [
    "body",
    "image",
    "increase",
    "lens",
    "more",
    "new",
    "photography",
    "picture",
    "snapshot"
  ],
  "av-camera-off": [
    "body",
    "disabled",
    "image",
    "lens",
    "no picture",
    "snapshot"
  ],
  "av-clap-board": [
    "begin",
    "clapper",
    "information",
    "movie",
    "recording",
    "scene",
    "tv"
  ],
  "av-display-surround": ["panorama", "panoramic", "screen", "wrap around"],
  "av-eject": ["media", "remove", "unmount"],
  "av-equalizer": [
    "bars",
    "base",
    "eq",
    "frequencies",
    "frequency",
    "levels",
    "mids",
    "treble",
    "volume"
  ],
  "av-faders": ["levels", "mute", "settings", "sliders", "solo", "soundboard"],
  "av-fast-forward": ["control", "playback", "transport"],
  "av-fast-reverse": ["control", "playback", "rewind", "transport"],
  "av-film": [
    "cells",
    "clip",
    "movie",
    "perforations",
    "reel",
    "strip",
    "video"
  ],
  "av-film-add": ["animation", "media", "more", "movie", "plus"],
  "av-film-collection": [
    "cells",
    "clips",
    "group",
    "movies",
    "perforations",
    "reel",
    "stack",
    "strips",
    "videos"
  ],
  "av-forward-10": ["advance", "jump", "skip"],
  "av-fps": [
    "frames per second",
    "hertz",
    "performance",
    "refresh rate",
    "speed"
  ],
  "av-high-quality": ["image", "iq", "performance", "video"],
  "av-hud": ["components", "heads up display", "overlay", "widgets"],
  "av-loop": ["again", "audio", "music", "repeat"],
  "av-loop-off": ["audio", "disabled", "music", "no repeat", "stop repeating"],
  "av-microphone": ["audio", "capsule", "receive", "record", "stand", "voice"],
  "av-microphone-off": [
    "audio",
    "capsule",
    "disabled",
    "no voice",
    "receive",
    "stand"
  ],
  "av-next": ["after", "end", "jump", "skip"],
  "av-notes": ["bar", "melody", "music", "notation"],
  "av-pause": ["control", "playback", "stop", "transport"],
  "av-picture-in-picture": ["mini", "preview", "small", "video", "window"],
  "av-play": [
    "begin",
    "control",
    "go",
    "move",
    "playback",
    "start",
    "transport"
  ],
  "av-previous": ["before", "beginning", "jump", "prior", "skip"],
  "av-record": ["capture", "control", "grab", "media", "playback", "transport"],
  "av-replay": ["again", "feature", "movies", "shadowplay", "videos"],
  "av-replay-off": ["again", "movies", "no feature", "shadowplay", "videos"],
  "av-reverse-10": ["backward", "jump", "rewind", "skip"],
  "av-soundwaves": ["amplitude", "audio", "levels"],
  "av-speaker": ["audio", "music", "sound", "volume"],
  "av-speaker-high": ["audio", "loud", "max", "music", "sound", "volume"],
  "av-speaker-low": ["audio", "min", "music", "quiet", "sound", "volume"],
  "av-speaker-medium": [
    "audio",
    "medium",
    "music",
    "normal",
    "sound",
    "volume"
  ],
  "av-speaker-mute": ["audio", "music", "quiet", "sound", "volume"],
  "av-speaker-off": ["audio", "disabled", "music", "sound", "volume"],
  "av-step-forward": ["frame", "jump", "next", "skip", "slow"],
  "av-step-reverse": ["frame", "jump", "previous", "prior", "skip", "slow"],
  "av-stop": ["control", "end", "playback", "transport"],
  "av-videocam": ["action", "camera", "live", "movie", "playback", "record"],
  "av-videocam-off": [
    "action",
    "disabled",
    "live",
    "movie",
    "no camera",
    "playback",
    "record"
  ],
  "av-watch-party": [
    "event",
    "group",
    "keynote",
    "presentation",
    "session",
    "streaming",
    "video",
    "view"
  ],
  "common-add": ["create", "cross", "crosshair", "expand", "new", "plus"],
  "common-add-circle": [
    "create",
    "cross",
    "crosshair",
    "expand",
    "new",
    "plus"
  ],
  "common-alarm": [
    "alert",
    "bell",
    "buzzer",
    "clock",
    "expire",
    "reminder",
    "ring",
    "signal",
    "time",
    "wake"
  ],
  "common-bell": ["alarm", "alert", "notification", "reminder", "ring"],
  "common-bell-off": ["alert", "no alarm", "notification", "reminder", "ring"],
  "common-calendar": [
    "date",
    "day",
    "event",
    "incident",
    "month",
    "picker",
    "schedule",
    "week",
    "year"
  ],
  "common-calendar-event": [
    "date",
    "day",
    "event",
    "incident",
    "month",
    "picker",
    "schedule",
    "special",
    "week",
    "year"
  ],
  "common-cancel": ["against", "anti", "delete", "remove"],
  "common-check": [
    "approve",
    "done",
    "finish",
    "form",
    "list",
    "mark",
    "success",
    "tick",
    "valid"
  ],
  "common-check-circle": [
    "approve",
    "done",
    "finish",
    "form",
    "list",
    "mark",
    "success",
    "tick",
    "valid"
  ],
  "common-check-multi-circle": [
    "approve",
    "bulk",
    "done",
    "double",
    "finish",
    "form",
    "list",
    "mark",
    "success",
    "tick",
    "valid",
    "validated"
  ],
  "common-clipboard": ["copy", "edit", "paste", "store", "temporary"],
  "common-clock": [
    "delay",
    "face",
    "hands",
    "period",
    "time",
    "timing",
    "wait",
    "watch"
  ],
  "common-close": [
    "cancel",
    "delete",
    "dismiss",
    "exit",
    "fail",
    "failure",
    "remove"
  ],
  "common-close-circle": [
    "cancel",
    "delete",
    "dismiss",
    "exit",
    "fail",
    "failure",
    "remove"
  ],
  "common-cog": [
    "configuration",
    "gear",
    "preferences",
    "settings",
    "setup",
    "setup"
  ],
  "common-cog-off": [
    "configuration",
    "no gear",
    "preferences",
    "settings",
    "setup",
    "setup"
  ],
  "common-copy-doc": ["clone", "duplicate", "pages"],
  "common-copy-generic": ["clone", "duplicate"],
  "common-enter": ["access", "go", "login", "signin"],
  "common-error": [
    "blocker",
    "crash",
    "critical",
    "failure",
    "issue",
    "terminal"
  ],
  "common-exit": ["close", "escape", "exit", "get out", "leave", "shutdown"],
  "common-eye": [
    "enable",
    "eye",
    "eyeball",
    "open",
    "show",
    "visibility",
    "visible"
  ],
  "common-eye-off": [
    "close",
    "disable",
    "eyeball",
    "hidden",
    "invisibility",
    "invisible",
    "no eye"
  ],
  "common-filter": ["funnel", "reduce", "refine"],
  "common-help-circle": [
    "answers",
    "faq",
    "mark",
    "query",
    "question",
    "support"
  ],
  "common-history": [
    "archive",
    "backup",
    "events",
    "happened",
    "old",
    "past",
    "previous",
    "recall",
    "sequence",
    "time"
  ],
  "common-home": ["building", "house", "main", "start"],
  "common-home-off": ["building", "house", "main", "no start"],
  "common-info-circle": [
    "attention",
    "contextual",
    "fyi",
    "help",
    "information",
    "news",
    "tip"
  ],
  "common-link": ["chain", "connection", "hyperlink", "jump", "url", "web"],
  "common-link-break": [
    "chain",
    "connection",
    "hyperlink",
    "jump",
    "remove",
    "url",
    "web"
  ],
  "common-lock-closed": [
    "access",
    "key",
    "keyhole",
    "locked",
    "padlock",
    "password",
    "privacy",
    "private",
    "protection",
    "safe",
    "secure",
    "security"
  ],
  "common-lock-open": [
    "access",
    "key",
    "keyhole",
    "padlock",
    "password",
    "privacy",
    "private",
    "protection",
    "safe",
    "secure",
    "security",
    "unlocked"
  ],
  "common-magnifying-glass": [
    "enlarge",
    "find",
    "inspect",
    "magnifier",
    "shrink",
    "view",
    "zoom"
  ],
  "common-magnifying-glass-minus": [
    "magnifier",
    "reduce",
    "shrink",
    "view",
    "zoom out"
  ],
  "common-magnifying-glass-plus": ["enlarge", "magnifier", "view", "zoom in"],
  "common-menu": [
    "burger",
    "drawer",
    "hamburger",
    "list",
    "nav",
    "navigation",
    "stack"
  ],
  "common-more-horiz": [
    "configuration",
    "dots",
    "ellipses",
    "ellipsis",
    "menu",
    "options"
  ],
  "common-more-vert": [
    "configuration",
    "dots",
    "ellipses",
    "ellipsis",
    "menu",
    "options"
  ],
  "common-paperplane": ["email", "flying", "folded", "message", "send"],
  "common-redo": ["again", "arrow", "forward", "next", "restore"],
  "common-refresh": ["check", "replenish", "restore", "try again", "update"],
  "common-reset": ["boot", "cycle", "replay", "start over", "try again"],
  "common-retry": ["again", "attempt"],
  "common-share": [
    "colleagues",
    "community",
    "coworkers",
    "distribute",
    "friends",
    "give",
    "message",
    "send",
    "social"
  ],
  "common-sort": ["hierarchy", "order", "sequence"],
  "common-star": ["award", "favorite", "level", "rate", "rating"],
  "common-subtract": ["delete", "minus", "remove"],
  "common-subtract-circle": ["delete", "minus", "remove"],
  "common-sync": [
    "activity",
    "arrows",
    "connection",
    "feedback",
    "recurring",
    "schedule"
  ],
  "common-sync-off": [
    "activity",
    "arrows",
    "feedback",
    "no connection",
    "recurring",
    "schedule"
  ],
  "common-timer": ["clock", "measure", "period", "race", "stop watch", "time"],
  "common-trash": [
    "bin",
    "can",
    "delete",
    "garbage",
    "recycle",
    "remove",
    "rubbish",
    "waste"
  ],
  "common-undo": [
    "arrow",
    "back",
    "backwards",
    "previous",
    "reverse",
    "revert"
  ],
  "common-warning": [
    "alert",
    "attention",
    "caution",
    "danger",
    "error",
    "feedback",
    "issue",
    "triangle"
  ],
  "communication-cloud": [
    "data center",
    "internet",
    "server",
    "wan",
    "weather",
    "wide area network"
  ],
  "communication-cloud-off": [
    "data center",
    "internet",
    "no weather",
    "server",
    "wan",
    "wide area network"
  ],
  "communication-data": [
    "binary",
    "bits",
    "information",
    "process",
    "receive",
    "send",
    "transmit"
  ],
  "communication-download": ["down arrow", "get", "pull", "save"],
  "communication-envelope": ["email", "mail", "message", "send"],
  "communication-envelope-off": ["mail", "message", "no email", "send"],
  "communication-firewall": ["block", "networking", "security"],
  "communication-firewall-off": ["block", "no networking", "security"],
  "communication-forward": ["next", "pass along", "send"],
  "communication-isp": ["internet", "network", "online", "wan", "web", "www"],
  "communication-isp-off": [
    "internet",
    "no network",
    "online",
    "wan",
    "web",
    "www"
  ],
  "communication-network-signal": ["activity", "node", "origin", "pulse"],
  "communication-network-signal-off": [
    "activity",
    "no origin",
    "node",
    "pulse"
  ],
  "communication-reply": ["react", "response", "return", "send back"],
  "communication-sync-warning": [
    "blocked",
    "broken",
    "error",
    "issue",
    "stopped"
  ],
  "communication-transfer-horizontal": [
    "displace",
    "exchange",
    "horizontal",
    "migrate",
    "move",
    "relocate",
    "shift",
    "sideways",
    "switch"
  ],
  "communication-transfer-vertical": [
    "displace",
    "exchange",
    "migrate",
    "move",
    "relocate",
    "shift",
    "switch",
    "vertical"
  ],
  "communication-upload": ["push", "put", "send", "up arrow"],
  "communication-wifi": [
    "hotspot",
    "internet",
    "reception",
    "signal",
    "waves",
    "wireless"
  ],
  "communication-wifi-off": [
    "disabled",
    "hotspot",
    "internet",
    "reception",
    "signal",
    "waves",
    "wireless"
  ],
  "cursor-arrow": ["click", "mouse", "pointer", "select"],
  "cursor-crosshair": ["aim", "drop", "reticle", "sight", "target"],
  "cursor-hand-closed": ["choose", "grab", "hold", "select"],
  "cursor-hand-open": ["choose", "pan", "select", "wave"],
  "cursor-hand-pinch": ["gesture", "motion", "pull", "zoom"],
  "cursor-hand-point": [
    "choose",
    "direct",
    "index finger",
    "point",
    "select",
    "tap",
    "touch"
  ],
  "cursor-hourglass": ["busy", "delay", "pause", "process", "wait"],
  "cursor-hourglass-end": ["busy", "delay", "pause", "process", "wait"],
  "cursor-hourglass-mid": ["busy", "delay", "pause", "process", "wait"],
  "cursor-hourglass-start": ["busy", "delay", "pause", "process", "wait"],
  "editor-anchor-center": ["lock", "middle", "origin", "point", "tie"],
  "editor-anchor-e": ["lock", "origin", "point", "right", "tie"],
  "editor-anchor-n": ["lock", "origin", "point", "tie", "top", "up"],
  "editor-anchor-ne": ["lock", "origin", "point", "right", "tie", "top", "up"],
  "editor-anchor-nw": ["left", "lock", "origin", "point", "tie", "top", "up"],
  "editor-anchor-s": ["bottom", "lock", "origin", "point", "tie"],
  "editor-anchor-se": ["bottom", "lock", "origin", "point", "right", "tie"],
  "editor-anchor-sw": ["bottom", "left", "lock", "origin", "point", "tie"],
  "editor-anchor-w": ["left", "lock", "origin", "point", "tie"],
  "editor-at-symbol": ["email", "receiver", "recipient", "target", "to"],
  "editor-backspace": ["character", "delete", "keystroke", "undo"],
  "editor-bold": ["document", "emphasis", "format", "heavy", "strong", "text"],
  "editor-branch": [
    "change",
    "control",
    "git",
    "new",
    "source",
    "test",
    "version"
  ],
  "editor-chart": [
    "change",
    "data viz",
    "diagram",
    "graph",
    "time series",
    "visualization"
  ],
  "editor-chart-bar": [
    "amount",
    "data viz",
    "diagram",
    "graph",
    "groups",
    "histogram",
    "vertical",
    "visualization"
  ],
  "editor-chart-flow": [
    "connectors",
    "diagram",
    "direction",
    "graph",
    "lines",
    "nodes"
  ],
  "editor-chart-hierarchy": [
    "diagram",
    "graph",
    "position",
    "rank",
    "structure",
    "taxonomy",
    "team"
  ],
  "editor-chart-performance": [
    "change",
    "data viz",
    "direction",
    "goal",
    "movement",
    "trend",
    "visualization"
  ],
  "editor-chart-pie": [
    "circle",
    "data viz",
    "diagram",
    "fraction",
    "graph",
    "segment",
    "visualization",
    "whole"
  ],
  "editor-chart-tree": [
    "diagram",
    "graph",
    "leaf",
    "leaves",
    "structure",
    "taxonomy",
    "team",
    "trunk"
  ],
  "editor-collapse": ["hide", "minimize", "reduce", "smaller"],
  "editor-commit": ["base", "code", "control", "git", "source", "version"],
  "editor-compare": [
    "check",
    "code",
    "control",
    "diff",
    "git",
    "source",
    "text",
    "version"
  ],
  "editor-connection": ["bridge", "line", "link", "nodes", "together"],
  "editor-expand": ["bigger", "expand", "larger", "show"],
  "editor-export-to-clipboard": ["copy", "memory"],
  "editor-fit": ["conform", "enlarge", "expand", "fill", "reduce", "shrink"],
  "editor-fork": [
    "clone",
    "control",
    "copy",
    "git",
    "new",
    "source",
    "version"
  ],
  "editor-freehand": ["draw", "form", "natural", "organic", "scribble"],
  "editor-grid": [
    "blocks",
    "edges",
    "frames",
    "lattice",
    "no guidelines",
    "regions"
  ],
  "editor-grid-off": [
    "blocks",
    "edges",
    "frames",
    "lattice",
    "no guidelines",
    "regions"
  ],
  "editor-h-align-center": [
    "arrange",
    "horizontal",
    "middle",
    "objects",
    "side"
  ],
  "editor-h-align-left": ["arrange", "flush", "horizontal", "objects", "side"],
  "editor-h-align-right": ["arrange", "flush", "horizontal", "objects", "side"],
  "editor-header": ["headline", "hook", "main", "sub", "summary", "title"],
  "editor-image": [
    "drawing",
    "graphic",
    "media",
    "painting",
    "photography",
    "picture",
    "print"
  ],
  "editor-italic": ["document", "emphasis", "oblique", "slant", "text"],
  "editor-iterate": ["cycles", "iterations", "passes", "repeats", "steps"],
  "editor-keyframe": ["adjust", "change", "node", "point", "stop", "tween"],
  "editor-layers": ["order", "overlay", "pile", "stack"],
  "editor-layers-off": ["no order", "overlay", "pile", "stack"],
  "editor-line-segment": ["line", "nodes", "piece", "straight"],
  "editor-list-bullet": ["collection", "group", "sequence", "unordered"],
  "editor-list-checkmark": [
    "collection",
    "group",
    "notes",
    "reminder",
    "schedule",
    "sequence",
    "summary",
    "tasks",
    "to do",
    "unordered",
    "work"
  ],
  "editor-list-number": ["collection", "group", "ordered", "sequence", "steps"],
  "editor-markdown": ["documentation", "format", "shorthand", "syntax"],
  "editor-merge": [
    "checkin",
    "control",
    "git",
    "source",
    "sync",
    "update",
    "version"
  ],
  "editor-move": ["adjust", "arrows", "change", "cross", "relocate"],
  "editor-numbers": ["count", "digits", "numeric", "values"],
  "editor-paperclip": ["addition", "attachment", "extra", "file"],
  "editor-paragraph": [
    "characters",
    "document",
    "hidden",
    "new",
    "processor",
    "special",
    "start",
    "text"
  ],
  "editor-pencil": [
    "change",
    "create",
    "draw",
    "edit",
    "modify",
    "pencil",
    "stylus",
    "write"
  ],
  "editor-pull": [
    "code",
    "control",
    "git",
    "refresh",
    "source",
    "sync",
    "version"
  ],
  "editor-pull-close": [
    "cancel",
    "close",
    "code",
    "control",
    "delete",
    "git",
    "remove",
    "source",
    "version"
  ],
  "editor-pull-draft": [
    "code",
    "control",
    "git",
    "source",
    "temporary",
    "version",
    "working"
  ],
  "editor-rotate": [
    "arrows",
    "circle",
    "pivot",
    "roll",
    "spin",
    "swivel",
    "twirl"
  ],
  "editor-rotate-90-clockwise": [
    "rectangular",
    "right",
    "spin",
    "square",
    "turn"
  ],
  "editor-rotate-90-counter": ["left", "rectangular", "spin", "square", "turn"],
  "editor-ruler": ["distance", "measurement", "size", "straightedge"],
  "editor-scale-down": ["collapse", "reduce", "resize", "shrink"],
  "editor-scale-reset": ["original", "resize", "start"],
  "editor-scale-up": ["expand", "grow", "resize", "stretch"],
  "editor-scissors": ["break", "copy", "cut", "slice", "split"],
  "editor-section": ["choose", "mark", "pick", "portion"],
  "editor-section-bottom": [
    "choose",
    "lower",
    "mark",
    "pick",
    "portion",
    "under"
  ],
  "editor-section-top": ["choose", "mark", "over", "pick", "portion", "upper"],
  "editor-select-brush": ["choose", "mark", "paint", "pick", "stroke"],
  "editor-signature": ["autograph", "sign"],
  "editor-skip": ["avoid", "ignore", "over"],
  "editor-sliders": [
    "adjust",
    "configuration",
    "continuous",
    "controls",
    "options",
    "refine",
    "settings"
  ],
  "editor-sort-ascending": ["direction", "hierarchy", "order", "sequence"],
  "editor-sort-descending": ["direction", "hierarchy", "order", "sequence"],
  "editor-sticker": ["cover", "overlay", "superimpose", "tag"],
  "editor-sticker-image": [
    "copy",
    "information",
    "on top",
    "overlay",
    "type",
    "write"
  ],
  "editor-sticker-shape": [
    "copy",
    "information",
    "on top",
    "overlay",
    "type",
    "write"
  ],
  "editor-sticker-text": [
    "copy",
    "information",
    "on top",
    "overlay",
    "type",
    "write"
  ],
  "editor-sticker-zoom": [
    "copy",
    "information",
    "on top",
    "overlay",
    "type",
    "write"
  ],
  "editor-strikethrough": ["document", "recant", "redact", "remove", "text"],
  "editor-stroke-width": ["edge", "line", "thickness"],
  "editor-style": ["customize", "freestyle", "look", "visuals"],
  "editor-swatches": [
    "cards",
    "categories",
    "fan",
    "sets",
    "stack",
    "styles",
    "types"
  ],
  "editor-text": ["dictate", "document", "letters", "type", "words", "write"],
  "editor-text-align-center": [
    "balanced",
    "format",
    "middle",
    "ragged",
    "text"
  ],
  "editor-text-align-full": ["flush", "format", "full", "justified", "text"],
  "editor-text-align-left": ["flush", "format", "justified", "text"],
  "editor-text-align-right": ["flush", "format", "justified", "text"],
  "editor-text-framed": ["background", "boundary", "box", "color", "region"],
  "editor-trash-delete": ["empty", "files", "garbage can", "permanent"],
  "editor-typography": [
    "appearance",
    "font",
    "format",
    "legibility",
    "letters",
    "readability",
    "style",
    "words"
  ],
  "editor-underline": ["document", "emphasis", "hyperlink", "rule", "text"],
  "editor-v-align-bottom": ["arrange", "flush", "objects", "side", "vertical"],
  "editor-v-align-center": ["arrange", "middle", "objects", "side", "vertical"],
  "editor-v-align-top": ["arrange", "flush", "objects", "side", "vertical"],
  "editor-wand": ["automatic", "fix", "improve", "instant", "magic", "wizard"],
  "editor-wrench": ["adjust", "build", "customize", "fix", "repair", "tool"],
  "files-archive": ["box", "deep", "save", "shelf", "storage", "store"],
  "files-db": ["database", "records", "save", "sql", "storage"],
  "files-document": ["corner", "empty", "fold", "new", "page", "sheet"],
  "files-document-checkmark": [
    "confirmed",
    "corner",
    "done",
    "empty",
    "finished",
    "fold",
    "new",
    "page",
    "sheet",
    "validated"
  ],
  "files-document-new": [
    "corner",
    "empty",
    "fold",
    "new",
    "page",
    "plus",
    "sheet"
  ],
  "files-document-preview": [
    "find",
    "look",
    "render",
    "search",
    "wysiwyg",
    "zoom"
  ],
  "files-export": ["convert", "process", "send", "share", "translate"],
  "files-floppy": ["data", "disk", "save", "storage", "store"],
  "files-folder-closed": ["container", "directory", "files", "path"],
  "files-folder-open": ["container", "directory", "files", "get", "path"],
  "files-import": ["convert", "embed", "insert", "process", "translate"],
  "hardware-2-b-left-click": ["action", "buttons", "indicator"],
  "hardware-battery-0": ["empty", "level", "power"],
  "hardware-battery-0-off": ["empty", "level", "power"],
  "hardware-battery-100": ["charged", "full", "level", "power"],
  "hardware-battery-25": ["level", "low", "power"],
  "hardware-battery-50": ["half", "level", "medium", "power"],
  "hardware-battery-75": ["healthy", "level", "power"],
  "hardware-battery-boost": ["feature", "power", "savings"],
  "hardware-battery-charging": ["level", "plugged in", "power"],
  "hardware-bluetooth": [
    "format",
    "peripheral",
    "standard",
    "type",
    "wireless"
  ],
  "hardware-bluetooth-off": [
    "format",
    "peripheral",
    "standard",
    "type",
    "wireless"
  ],
  "hardware-calculator": ["classic", "crunch", "display", "numbers", "old"],
  "hardware-cpu": ["central processing unit", "chip", "micro", "processor"],
  "hardware-display": ["landscape", "monitor", "screen"],
  "hardware-display-collection": ["monitor", "mosaic", "multimon", "surround"],
  "hardware-display-off": ["landscape", "monitor", "screen"],
  "hardware-drive-cloud": [
    "data center",
    "internet",
    "save",
    "server",
    "storage",
    "store"
  ],
  "hardware-drive-cloud-off": [
    "data center",
    "internet",
    "save",
    "server",
    "storage",
    "store"
  ],
  "hardware-drive-network": [
    "attached",
    "data center",
    "save",
    "server",
    "storage",
    "store"
  ],
  "hardware-drive-network-off": [
    "attached",
    "data center",
    "save",
    "server",
    "storage",
    "store"
  ],
  "hardware-drive-removable": [
    "bernoulli",
    "disk",
    "floppy",
    "media",
    "optical",
    "save",
    "storage",
    "store",
    "zip"
  ],
  "hardware-drive-removable-off": [
    "bernoulli",
    "disk",
    "floppy",
    "media",
    "optical",
    "save",
    "storage",
    "store",
    "zip"
  ],
  "hardware-drive-usb": ["data", "flash", "memory", "save", "storage", "store"],
  "hardware-drive-usb-off": [
    "data",
    "flash",
    "memory",
    "save",
    "storage",
    "store"
  ],
  "hardware-ethernet": [
    "connector",
    "internet",
    "lan",
    "local area network",
    "patch cable",
    "port",
    "server"
  ],
  "hardware-fan": ["flow", "hardware", "noise", "temperature"],
  "hardware-fan-loud": ["air", "high power", "noise", "speed", "volume"],
  "hardware-fan-quiet": [
    "air",
    "low power",
    "noise",
    "silent",
    "speed",
    "volume"
  ],
  "hardware-gamepad": [
    "buttons",
    "console",
    "controller",
    "dpad",
    "shield",
    "video games"
  ],
  "hardware-gamepad-off": [
    "buttons",
    "console",
    "controller",
    "dpad",
    "shield",
    "video games"
  ],
  "hardware-gamepad-start": ["controller", "start"],
  "hardware-gpu": ["chip", "graphics processing unit", "micro", "processor"],
  "hardware-gpu-card": [
    "dedicated",
    "discreet",
    "expansion",
    "motherboard",
    "pci"
  ],
  "hardware-gpu-card-multi": [
    "dedicated",
    "discreet",
    "expansion",
    "group",
    "lda",
    "motherboard",
    "multiple",
    "pci",
    "sli"
  ],
  "hardware-gpu-card-off": [
    "dedicated",
    "discreet",
    "expansion",
    "motherboard",
    "pci"
  ],
  "hardware-gpu-off": [
    "chip",
    "graphics processing unit",
    "micro",
    "processor"
  ],
  "hardware-headset": [
    "audio",
    "av",
    "chat",
    "headphones",
    "microphone",
    "sound",
    "speaker",
    "voice"
  ],
  "hardware-keyboard": ["data entry", "input", "keys", "peripheral", "type"],
  "hardware-laptop": ["computer", "notebook", "portable"],
  "hardware-lightning": [
    "electricity",
    "event",
    "instance",
    "juice",
    "power",
    "surprise"
  ],
  "hardware-mac": [
    "apple",
    "display",
    "imac",
    "macintosh",
    "monitor",
    "screen"
  ],
  "hardware-mac-off": [
    "apple",
    "display",
    "imac",
    "macintosh",
    "monitor",
    "screen"
  ],
  "hardware-media-optical": ["cd", "disc", "dvd", "installer"],
  "hardware-mosaic": [
    "cave",
    "combined displays",
    "fabric",
    "resolution",
    "wall"
  ],
  "hardware-mouse-2-b": ["buttons", "cursor", "input", "peripheral", "track"],
  "hardware-mouse-2-b-right-click": ["action", "buttons", "indicator"],
  "hardware-mouse-3-b": ["buttons", "cursor", "input", "peripheral", "track"],
  "hardware-mouse-scrollwheel": [
    "buttons",
    "cursor",
    "input",
    "peripheral",
    "track"
  ],
  "hardware-mouse-scrollwheel-active": [
    "action",
    "buttons",
    "indicator",
    "wheel"
  ],
  "hardware-multidrive": [
    "array",
    "discs",
    "hard drives",
    "hdd",
    "raid",
    "save",
    "storage",
    "store",
    "stripe"
  ],
  "hardware-network": [
    "connections",
    "diagram",
    "hub",
    "lines",
    "nodes",
    "web"
  ],
  "hardware-network-connection": ["ethernet", "lan", "local area network"],
  "hardware-network-pcs": [
    "cluster",
    "computers",
    "connection",
    "group",
    "lan",
    "local area"
  ],
  "hardware-nvidia-shield": ["console", "set top box", "stb"],
  "hardware-nvidia-shield-stand": ["console", "set top box", "stb", "vertical"],
  "hardware-performance-high": [
    "benchmark",
    "capacity",
    "dashboard",
    "gauge",
    "high",
    "measure",
    "threshold"
  ],
  "hardware-performance-low": [
    "benchmark",
    "capacity",
    "dashboard",
    "gauge",
    "low",
    "measure",
    "threshold"
  ],
  "hardware-performance-medium": [
    "benchmark",
    "capacity",
    "dashboard",
    "gauge",
    "measure",
    "medium",
    "threshold"
  ],
  "hardware-phone-laptop": [
    "android",
    "combo",
    "computer",
    "gadget",
    "handset",
    "iphone",
    "notebook",
    "pair",
    "portable"
  ],
  "hardware-plug-recepticle": [
    "connect",
    "couple",
    "electricity",
    "power",
    "socket"
  ],
  "hardware-plug-usb": ["cable", "connect"],
  "hardware-plugin": ["electricity", "power", "prongs"],
  "hardware-power": [
    "circuit",
    "device",
    "electronics",
    "flow",
    "hardware",
    "state"
  ],
  "hardware-ram": ["chip", "micro", "random access memory", "storage"],
  "hardware-remote": [
    "control",
    "distance",
    "gadget",
    "shield",
    "television",
    "tv"
  ],
  "hardware-robot-arm": [
    "articulation",
    "automation",
    "dexterity",
    "simulation"
  ],
  "hardware-sd-card": ["camera", "data", "memory", "save", "storage", "store"],
  "hardware-smartphone": ["android", "gadget", "handset", "iphone"],
  "hardware-smartphone-off": ["android", "gadget", "handset", "iphone"],
  "hardware-tablet": ["android", "gadget", "ipad", "kindle", "slate"],
  "hardware-tablet-off": ["android", "gadget", "ipad", "kindle", "slate"],
  "hardware-telephone": [
    "answer",
    "call",
    "communications",
    "handset",
    "pickup"
  ],
  "hardware-telephone-off": [
    "answer",
    "call",
    "communications",
    "handset",
    "pickup"
  ],
  "hardware-usb": ["format", "peripheral", "standard", "type", "wired"],
  "hardware-vr": ["goggles", "peripheral", "track", "virtual reality"],
  "hardware-watch": ["clock", "time", "wearable", "wrist"],
  "hardware-webcam": ["camera", "meetings", "mount", "video chat"],
  "hardware-webcam-off": ["camera", "meetings", "mount", "video chat"],
  "hardware-webcam-settings": [
    "adjust",
    "camera",
    "config",
    "meetings",
    "mount",
    "settings",
    "video chat"
  ],
  "hardware-whispermode": [
    "fan",
    "feature",
    "noise",
    "quiet",
    "silent",
    "volume"
  ],
  "hardware-wireless-modem": [
    "internet",
    "lan",
    "network",
    "router",
    "signal",
    "wap",
    "wifi"
  ],
  "hardware-wireless-modem-off": [
    "internet",
    "lan",
    "network",
    "router",
    "signal",
    "wap",
    "wifi"
  ],
  "hardware-workstation": ["computer", "desktop", "pc", "tower"],
  "hardware-workstation-off": ["computer", "desktop", "pc", "tower"],
  "hardware-workstation-system": [
    "computer",
    "desktop",
    "display",
    "monitor",
    "pc",
    "tower"
  ],
  "hardware-workstation-system-off": [
    "computer",
    "desktop",
    "display",
    "monitor",
    "pc",
    "tower"
  ],
  "image-brush": ["coloring", "drawing", "painting", "strokes"],
  "image-bucket": ["art", "colors", "fill", "flood", "paint"],
  "image-camera-360": ["environment", "surround", "vr"],
  "image-camera-linked": [
    "attached",
    "connected",
    "images",
    "photos",
    "wireless"
  ],
  "image-camera-super": [],
  "image-collection": [
    "collection",
    "drawing",
    "graphic",
    "group",
    "media",
    "painting",
    "photography",
    "picture",
    "print",
    "stack"
  ],
  "image-crop": ["area", "artboard", "aspect ratio", "clip", "trim"],
  "image-denoise": ["clarify", "refine", "simplify"],
  "image-easel": ["display", "present", "showcase", "stand"],
  "image-eraser": ["delete", "remove", "scrub"],
  "image-eyedropper": ["color", "format", "picker", "sampler", "style"],
  "image-group": ["cluster", "collection", "surround", "team", "together"],
  "image-import-image": [
    "convert",
    "embed",
    "insert",
    "picture",
    "process",
    "translate",
    "visual"
  ],
  "image-mask-inside": ["affect", "area", "interior", "region", "select"],
  "image-mask-outside": ["affect", "area", "exterior", "region", "select"],
  "image-mirror": ["reflect", "reverse"],
  "image-outpainting": ["canvas", "create", "extend", "grow", "stretch"],
  "image-palette": ["collection", "colors", "picker"],
  "image-scale": ["adjust", "bigger", "expand", "reduce", "resize", "shrink"],
  "image-scale-relative": [
    "aspect ratio",
    "enlarge",
    "maintain",
    "reduce",
    "shrink"
  ],
  "image-scale-relative-off": [
    "aspect ratio",
    "maintain",
    "no enlarge",
    "reduce",
    "shrink"
  ],
  "image-select-ellipse": [
    "area",
    "border",
    "boundary",
    "circle",
    "mask",
    "portion",
    "region",
    "round",
    "segment"
  ],
  "image-select-polygon": [
    "area",
    "border",
    "boundary",
    "custom",
    "irregular",
    "mask",
    "portion",
    "region",
    "segment"
  ],
  "image-select-rectangle": [
    "area",
    "border",
    "boundary",
    "corner",
    "mask",
    "portion",
    "region",
    "segment",
    "square"
  ],
  "image-shapes": [
    "basic",
    "collection",
    "containers",
    "objects",
    "primitives",
    "simple"
  ],
  "image-sun-high": ["astronomy", "bright", "intensity", "light", "space"],
  "image-sun-low": ["astronomy", "dim", "intensity", "light", "space"],
  "image-sun-off-high": ["astronomy", "bright", "intensity", "light", "space"],
  "image-transparency": [
    "onion",
    "opacity",
    "see through",
    "skin",
    "translucency",
    "vellum"
  ],
  "maps-airplane": ["air", "flight", "fly", "jet", "travel"],
  "maps-briefcase": [
    "business",
    "documents",
    "job",
    "occupation",
    "portfolio",
    "work"
  ],
  "maps-bush": ["low", "plants", "shrubbery"],
  "maps-business": ["building", "city", "office", "skyscraper", "work"],
  "maps-dirt": ["ground", "particles", "soil"],
  "maps-elevator": ["floors", "lift", "mechanical"],
  "maps-escalator": ["floors", "mechanical", "stairs"],
  "maps-factory": ["building", "industry", "manufacture", "production"],
  "maps-flag": ["landmark", "location", "remember", "save"],
  "maps-flower": [
    "colorful",
    "grow",
    "leaves",
    "petals",
    "spring",
    "stems",
    "wild"
  ],
  "maps-fog": ["low clouds", "mist", "soupy", "visibility"],
  "maps-grass": ["green", "low", "pasture", "short"],
  "maps-gravel": ["pebbles", "river bank", "rocks", "stones"],
  "maps-hill": ["rise", "rolling"],
  "maps-location": ["geography", "marker", "pin", "place", "position"],
  "maps-location-off": ["geography", "marker", "pin", "place", "position"],
  "maps-map": ["directions", "fold", "geography", "location", "paper"],
  "maps-map-off": ["directions", "fold", "geography", "location", "paper"],
  "maps-mountain": ["high point", "peak", "range", "rocky"],
  "maps-mud": ["dirt", "water"],
  "maps-river": ["channel", "flow", "water"],
  "maps-rock": ["boulder", "ground"],
  "maps-sand": ["cactus", "desert", "dry", "dunes"],
  "maps-sea": ["ocean", "open water", "waves"],
  "maps-signpost": ["direction", "goal", "marker", "pointer", "waypoint"],
  "maps-sky": ["air", "birds", "horizon", "ocean", "sunset"],
  "maps-snow": [
    "cold",
    "crystal",
    "flake",
    "hexagonal",
    "temperature",
    "water"
  ],
  "maps-stair": ["emergency", "floors", "staircase", "stairwell"],
  "maps-stone": ["face", "hewn", "rock"],
  "maps-straw": ["grassland", "stalks", "tall"],
  "maps-suitcase": ["baggage", "clothes", "personal", "travel"],
  "maps-toolbox": [
    "adjust",
    "configuration",
    "customize",
    "fix",
    "repair",
    "utilities"
  ],
  "maps-tree": ["branches", "forest", "leaves", "trunk", "woods"],
  "maps-trees": ["forest", "grove", "stand", "woods"],
  "maps-water": ["lake", "liquid", "smooth", "still", "wet"],
  "maps-world": [
    "earth",
    "global",
    "globe",
    "internet",
    "planet",
    "wan",
    "www"
  ],
  "maps-world-off": [
    "earth",
    "global",
    "globe",
    "internet",
    "planet",
    "wan",
    "www"
  ],
  "misc-bandaid": ["fix", "health", "help", "medical", "patch"],
  "misc-beaker": [
    "experiment",
    "glass",
    "lab",
    "liquid",
    "science",
    "trial",
    "vial"
  ],
  "misc-blackboard": [
    "chalk",
    "classroom",
    "display",
    "dry erase",
    "education",
    "learning"
  ],
  "misc-book": [
    "content",
    "education",
    "learn",
    "library",
    "manual",
    "pages",
    "read",
    "study",
    "text"
  ],
  "misc-bug": ["code", "development", "error", "issue", "problem"],
  "misc-bug-off": ["code", "development", "error", "issue", "problem"],
  "misc-car": [
    "automobile",
    "drive",
    "driving",
    "passenger",
    "travel",
    "vehicle"
  ],
  "misc-checkmark-badge": ["approved", "award", "special", "star", "validated"],
  "misc-circle-1-q": [
    "animation",
    "delay",
    "hold",
    "pause",
    "spinner",
    "wait",
    "working"
  ],
  "misc-circle-2-q": [
    "animation",
    "delay",
    "hold",
    "pause",
    "spinner",
    "wait",
    "working"
  ],
  "misc-circle-3-q": [
    "animation",
    "delay",
    "hold",
    "pause",
    "spinner",
    "wait",
    "working"
  ],
  "misc-circle-tick": ["burst", "delay", "ios", "spinner", "waiting"],
  "misc-code": [
    "angle brackets",
    "cli",
    "close",
    "development",
    "open",
    "slash",
    "tags"
  ],
  "misc-compass": [
    "directions",
    "hike",
    "location",
    "magnetism",
    "north",
    "pathfinding"
  ],
  "misc-delivery-truck": ["cargo", "freight", "moving", "vehicle"],
  "misc-ekg": ["health", "heart", "monitor", "pulse"],
  "misc-function": [
    "algorithm",
    "complex",
    "compute",
    "input",
    "output",
    "process"
  ],
  "misc-gift": ["bow", "package", "present", "reward", "sash", "wrapped"],
  "misc-graduate": [
    "college",
    "education",
    "hat",
    "learning",
    "school",
    "tassle",
    "university"
  ],
  "misc-graph-node": [
    "activity",
    "input",
    "object",
    "output",
    "piece",
    "process"
  ],
  "misc-graph-node-connect": [
    "activity",
    "bridge",
    "input",
    "link",
    "object",
    "output",
    "piece",
    "process"
  ],
  "misc-graph-node-delete": [
    "activity",
    "input",
    "object",
    "output",
    "piece",
    "process",
    "remove"
  ],
  "misc-health": [
    "aid",
    "cross",
    "doctor",
    "emergency",
    "hospital",
    "medical",
    "nurse"
  ],
  "misc-hot-air-balloon": [
    "air",
    "classic",
    "explore",
    "rise",
    "travel",
    "whimsical"
  ],
  "misc-ime": ["input", "language", "method"],
  "misc-infinity": ["loop", "math", "neverending", "symbol", "unlimited"],
  "misc-key": ["access", "authentication", "entry", "lock", "open", "password"],
  "misc-library": [
    "books",
    "collection",
    "objects",
    "shelf",
    "stack",
    "volumes"
  ],
  "misc-library-games": [],
  "misc-lifebouy": ["float", "help", "ring", "safety"],
  "misc-lightbulb": ["bright", "idea", "thought"],
  "misc-magnet": ["attraction", "connection", "electromagnetism", "sticky"],
  "misc-man": ["male", "men", "restrooms"],
  "misc-man-woman": ["female", "male", "men", "restrooms", "women"],
  "misc-math": [
    "add",
    "divide",
    "multiply",
    "process",
    "solution",
    "solve",
    "subtract"
  ],
  "misc-megaphone": [
    "amplify",
    "announce",
    "bullhorn",
    "loudspeaker",
    "public address",
    "volume"
  ],
  "misc-microscope": ["inspect", "lab", "magnify", "science", "zoom"],
  "misc-mode-component": [
    "individual",
    "one",
    "single",
    "singular",
    "solo",
    "unique"
  ],
  "misc-money": [
    "bill",
    "coin",
    "currency",
    "generic",
    "stack",
    "tender",
    "universal",
    "wallet"
  ],
  "misc-money-coin": [
    "change",
    "currency",
    "generic",
    "tender",
    "universal",
    "wallet"
  ],
  "misc-money-paper": [
    "bill",
    "currency",
    "dollar",
    "frank",
    "generic",
    "note",
    "pound",
    "tender",
    "universal",
    "wallet"
  ],
  "misc-moon": ["crescent", "dark", "eclipse", "evening", "night", "space"],
  "misc-moon-off": ["crescent", "dark", "eclipse", "evening", "night", "space"],
  "misc-mug": [
    "beverage",
    "coffee",
    "cup",
    "drink",
    "hot",
    "hot chocolate",
    "steam",
    "tea",
    "warm"
  ],
  "misc-neural-network": [
    "ai",
    "artificial intelligence",
    "deep",
    "dl",
    "learning",
    "machine",
    "ml"
  ],
  "misc-news": [
    "articles",
    "headlines",
    "information",
    "pages",
    "periodical",
    "press",
    "tabloid",
    "update"
  ],
  "misc-package": ["address", "box", "label", "order", "send", "shipment"],
  "misc-payment-card": [
    "buy",
    "commerce",
    "credit",
    "debit",
    "finance",
    "money",
    "purchase",
    "shop",
    "swipe"
  ],
  "misc-pizza": ["cuisine", "food", "italian", "pie", "slice", "toppings"],
  "misc-prayer-room": ["chapel", "meditation", "quiet", "religion"],
  "misc-projector": ["display", "present", "showcase", "stand"],
  "misc-pulse": [
    "audio",
    "health",
    "heartbeat",
    "sound",
    "statistic",
    "wavelength"
  ],
  "misc-puzzle": ["component", "fit", "mystery", "piece"],
  "misc-qrcode": [
    "dots",
    "encode",
    "link",
    "mobile",
    "pattern",
    "quick redirect"
  ],
  "misc-radar": ["ping", "scan", "sensor", "sonar", "waves"],
  "misc-radioactive": ["energy", "nuclear", "warning"],
  "misc-rocket": [
    "explore",
    "launch",
    "science",
    "send",
    "shuttle",
    "space",
    "space",
    "start",
    "travel"
  ],
  "misc-running": [
    "action",
    "activity",
    "exercise",
    "figure",
    "movement",
    "person"
  ],
  "misc-scale-balance": ["compare", "even", "measures", "weights"],
  "misc-school": [
    "building",
    "education",
    "learning",
    "location",
    "place",
    "students",
    "teachers"
  ],
  "misc-seed": ["acorn", "grow", "plant", "randomization"],
  "misc-sensor": ["dish", "pickup", "receiver", "receptor", "signals"],
  "misc-shield": [
    "block",
    "elevation",
    "guard",
    "malware",
    "protection",
    "safety",
    "security",
    "virus"
  ],
  "misc-shield-off": [
    "block",
    "elevation",
    "guard",
    "malware",
    "protection",
    "safety",
    "security",
    "virus"
  ],
  "misc-ship-wheel": [
    "boat",
    "directions",
    "discover",
    "explore",
    "navigate",
    "steer"
  ],
  "misc-shopping-bag": [
    "bundle",
    "buy",
    "choose",
    "commerce",
    "purchase",
    "shop"
  ],
  "misc-shopping-basket": [
    "bag",
    "bundle",
    "buy",
    "checkout",
    "commerce",
    "items",
    "purchase",
    "store"
  ],
  "misc-shopping-cart": [
    "bundle",
    "buy",
    "checkout",
    "commerce",
    "items",
    "purchase",
    "store"
  ],
  "misc-shopping-cart-open": [
    "bundle",
    "buy",
    "checkout",
    "commerce",
    "contents",
    "filled",
    "items",
    "purchase",
    "store"
  ],
  "misc-sparkle": ["magic", "poof", "shiny", "stars", "twinkle", "whoosh"],
  "misc-tag": ["categorize", "flag", "label", "mark", "price"],
  "misc-tag-label": ["categorize", "flag", "label", "mark", "price"],
  "misc-telescope": [
    "astronomy",
    "explore",
    "optics",
    "planets",
    "science",
    "space",
    "stars",
    "zoom"
  ],
  "misc-thermometer": ["gauge", "measure", "temperature"],
  "misc-ticket": ["event", "pass", "redeem", "tix", "validation"],
  "misc-traffic-cone": [
    "barrier",
    "construction",
    "guidance",
    "marker",
    "safety",
    "warning"
  ],
  "misc-weight": ["big", "force", "heavy", "mass", "measurement"],
  "misc-weight-bar": ["barbell", "exercise", "heavy", "lift", "work out"],
  "misc-wheelchair": [
    "accessibility",
    "ada",
    "disabled",
    "handicap",
    "parking",
    "ramp",
    "space"
  ],
  "misc-woman": ["female", "restrooms", "women"],
  "shapes-arrow-down": ["bottom", "south"],
  "shapes-arrow-down-left": ["bottom", "diagonal", "south", "west"],
  "shapes-arrow-down-max": ["bottom", "edge", "end", "south"],
  "shapes-arrow-down-right": ["bottom", "diagonal", "east", "south"],
  "shapes-arrow-left": ["side", "west"],
  "shapes-arrow-left-max": ["edge", "end", "side", "west"],
  "shapes-arrow-left-right": [
    "expand",
    "horizontal",
    "left",
    "right",
    "sides",
    "stretch"
  ],
  "shapes-arrow-right": ["east", "side"],
  "shapes-arrow-right-max": ["east", "edge", "end", "side"],
  "shapes-arrow-up": ["north", "top"],
  "shapes-arrow-up-down": ["down", "expand", "stretch", "up", "vertical"],
  "shapes-arrow-up-left": ["diagonal", "north", "top", "west"],
  "shapes-arrow-up-max": ["edge", "end", "north", "top"],
  "shapes-arrow-up-right": ["diagonal", "east", "north", "top"],
  "shapes-chevron-double-down": ["arrows", "bottom", "south"],
  "shapes-chevron-double-left": ["arrows", "side", "west"],
  "shapes-chevron-double-right": ["arrows", "east", "side"],
  "shapes-chevron-double-up": ["arrows", "north", "top"],
  "shapes-chevron-down": ["arrow", "bottom", "south"],
  "shapes-chevron-down-left-up-right": [
    "arrows",
    "corners",
    "diagonal",
    "northeast",
    "southwest"
  ],
  "shapes-chevron-left": ["arrow", "west"],
  "shapes-chevron-left-right": ["arrows", "east", "sides", "west"],
  "shapes-chevron-right": ["arrow", "east"],
  "shapes-chevron-up": ["arrow", "north", "top"],
  "shapes-chevron-up-down": [
    "arrows",
    "bottom",
    "north",
    "sides",
    "south",
    "top"
  ],
  "shapes-chevron-up-left-down-right": [
    "arrows",
    "corners",
    "diagonal",
    "northwest",
    "southeast"
  ],
  "shapes-diamond": ["block", "instance", "mark", "simple"],
  "shapes-diamond-off": ["block", "instance", "mark", "no shape", "simple"],
  "shapes-return": ["carriage", "enter", "new line"],
  "shapes-shape-circle": ["basic", "dot", "ring", "simple"],
  "shapes-shape-circle-off": ["basic", "dot", "no simple", "ring"],
  "shapes-shape-hexagon": [
    "6",
    "basic",
    "bee",
    "honeycomb",
    "simple",
    "six",
    "tile"
  ],
  "shapes-shape-octogon": [
    "8",
    "alert",
    "basic",
    "eight",
    "sign",
    "simple",
    "stop"
  ],
  "shapes-shape-square": ["basic", "box", "simple"],
  "shapes-shape-square-off": [],
  "shapes-shape-triangle": ["alert", "basic", "danger", "simple", "warning"],
  "social-account-add": [
    "account",
    "add",
    "avatar",
    "new",
    "person",
    "photo",
    "user"
  ],
  "social-account-check": [
    "account",
    "avatar",
    "confirm",
    "inspect",
    "person",
    "photo",
    "user",
    "validate"
  ],
  "social-account-more": [
    "account",
    "actions",
    "additional",
    "avatar",
    "details",
    "information",
    "person",
    "photo",
    "user"
  ],
  "social-account-remove": [
    "account",
    "avatar",
    "delete",
    "person",
    "photo",
    "user"
  ],
  "social-award-ribbon": [
    "achievement",
    "certificate",
    "honor",
    "official",
    "prize",
    "reward",
    "win"
  ],
  "social-award-trophy": ["achievement", "honor", "prize", "reward", "win"],
  "social-baby": [
    "age",
    "care",
    "child",
    "father",
    "kid",
    "mother",
    "parents",
    "young"
  ],
  "social-bookmark": [
    "location",
    "mark",
    "note",
    "place",
    "position",
    "sash",
    "save"
  ],
  "social-bookmark-off": [
    "location",
    "mark",
    "note",
    "place",
    "position",
    "sash",
    "save"
  ],
  "social-chat-message": ["content", "speech bubble"],
  "social-chat-multi": ["conversation", "dialogue", "speech bubbles"],
  "social-chat-new": ["add", "new", "speech bubble"],
  "social-chat-single": ["empty", "speech bubble"],
  "social-chatbot": [
    "ai",
    "automation",
    "conversation",
    "llm",
    "replies",
    "reply",
    "smart",
    "virtual"
  ],
  "social-feeling-happy": [
    "emotion",
    "good",
    "positive",
    "rating",
    "satisfaction"
  ],
  "social-feeling-neutral": [
    "emotion",
    "neutral",
    "ok",
    "rating",
    "satisfaction"
  ],
  "social-feeling-sad": [
    "bad",
    "emotion",
    "negative",
    "poor",
    "rating",
    "satisfaction"
  ],
  "social-feeling-very-happy": [
    "emotion",
    "good",
    "positive",
    "rating",
    "satisfaction"
  ],
  "social-feeling-very-sad": [
    "bad",
    "emotion",
    "negative",
    "poor",
    "rating",
    "satisfaction"
  ],
  "social-founders": ["badge", "importance", "level"],
  "social-founders-tier-1": ["badge", "importance", "level"],
  "social-founders-tier-2": ["badge", "importance", "level"],
  "social-founders-tier-3": ["badge", "importance", "level"],
  "social-heart": ["favorite", "like", "rate", "rating", "romance", "save"],
  "social-heart-off": ["favorite", "like", "rate", "rating", "romance", "save"],
  "social-identification": [
    "badge",
    "card",
    "identity",
    "name",
    "photo",
    "security",
    "tag"
  ],
  "social-license": [
    "drivers",
    "identification",
    "identity",
    "legal",
    "name",
    "photo",
    "proof"
  ],
  "social-pin": ["keep", "present", "remember", "set", "thumbtack"],
  "social-pin-off": ["keep", "no thumbtack", "present", "remember", "set"],
  "social-profile": ["account", "avatar", "person", "photo", "user"],
  "social-profile-group": ["accounts", "avatars", "people", "photos", "users"],
  "social-profile-off": ["account", "avatar", "no user", "person", "photo"],
  "social-ranking-xp": ["badge", "experience", "level", "points", "skill"],
  "social-thumb-down": [
    "disapprove",
    "dislike",
    "negative",
    "opinion",
    "rate",
    "rating",
    "reject"
  ],
  "social-thumb-up": [
    "approve",
    "like",
    "opinion",
    "positive",
    "rate",
    "rating"
  ],
  "view-3-square-plus": [
    "add",
    "blocks",
    "four",
    "new",
    "quadrants",
    "sections",
    "split",
    "three"
  ],
  "view-4-square": ["blocks", "four", "quadrants", "sections", "split"],
  "view-apps": ["applications", "dashboard", "launcher"],
  "view-carousel-horizontal": [
    "billboard",
    "flow",
    "marquee",
    "order",
    "rotate"
  ],
  "view-carousel-vertical": ["billboard", "flow", "marquee", "order", "rotate"],
  "view-display-share": [
    "broadcast",
    "collaboration",
    "meeting",
    "screen",
    "send"
  ],
  "view-dual": [
    "draft",
    "final",
    "hybrid",
    "image",
    "landscape",
    "rough",
    "segmentation"
  ],
  "view-feedback": ["message", "speech bubble"],
  "view-fit-to-page": ["find", "look", "render", "search", "wysiwyg", "zoom"],
  "view-fullscreen": [
    "all",
    "bigger",
    "cover",
    "display",
    "enlarge",
    "fill",
    "maximize",
    "total"
  ],
  "view-fullscreen-exit": ["inset", "reduce", "restore", "smaller", "window"],
  "view-gallery-strip": ["browse", "images", "row", "thumbnails", "view"],
  "view-grip-area": ["drag", "grab", "region", "tactile"],
  "view-grip-corner": ["corner", "drag", "grab", "tactile"],
  "view-grip-edge-horizontal": ["drag", "grab", "strip", "tactile"],
  "view-grip-edge-vertical": ["drag", "grab", "strip", "tactile"],
  "view-grip-mini": ["drag", "grab", "strip", "tactile"],
  "view-layout-columns": ["grid", "template", "vertical"],
  "view-layout-detail": [
    "information",
    "list",
    "navigation",
    "panels",
    "sections"
  ],
  "view-layout-grid": ["blocks", "modules", "template"],
  "view-layout-list": ["grid", "template"],
  "view-layout-rows": ["grid", "horizontal", "template"],
  "view-map": ["draft", "rough", "segmentation"],
  "view-open-external": ["launch", "new", "outside", "share"],
  "view-pill-bar-stack": ["collection", "grouping", "properties", "tags"],
  "view-rectangle-group": ["areas", "arrange", "blocks", "gather", "sort"],
  "view-render": ["final", "hybrid", "image", "landscape"],
  "view-stack-horizontal": ["flow", "order", "overlay", "pile", "stack"],
  "view-window": ["application", "browser", "frame"],
  "view-window-code": [
    "developer",
    "ide",
    "integrated development environment"
  ],
  "view-window-grid": ["all up", "apps", "divided", "quadrants", "tiled"],
  "view-window-stack": [
    "applications",
    "apps",
    "collection",
    "group",
    "overlay"
  ],
  "view-window-terminal": [
    "cli",
    "command line interface",
    "console",
    "terminal"
  ],
  "view-workspace": [
    "applications",
    "apps",
    "desktop",
    "files",
    "job",
    "structure",
    "workflow"
  ],
  "view-workspace-group": [
    "applications",
    "apps",
    "collection",
    "desktop",
    "files",
    "job",
    "structure",
    "workflow"
  ]
}, m = [
  "av-camera-add",
  "av-forward-10",
  "av-reverse-10",
  "av-watch-party",
  "common-calendar-event",
  "common-check-multi-circle",
  "common-enter",
  "cursor-hourglass-end",
  "cursor-hourglass-mid",
  "cursor-hourglass-start",
  "editor-at-symbol",
  "editor-backspace",
  "editor-collapse",
  "editor-compare",
  "editor-connection",
  "editor-expand",
  "editor-header",
  "editor-markdown",
  "editor-numbers",
  "editor-pull-close",
  "editor-pull-draft",
  "editor-scissors",
  "editor-sort-ascending",
  "editor-sort-descending",
  "editor-typography",
  "files-document-checkmark",
  "hardware-headset",
  "hardware-phone-laptop",
  // normalization images-denoise -> image-denoise
  // "image-denoise",
  "maps-elevator",
  "maps-escalator",
  "maps-signpost",
  "maps-stair",
  "misc-car",
  "misc-checkmark-badge",
  "misc-circle-1-q",
  "misc-circle-2-q",
  "misc-circle-3-q",
  "misc-circle-tick",
  "misc-delivery-truck",
  "misc-graph-node-connect",
  "misc-graph-node-delete",
  "misc-infinity",
  "misc-lifebouy",
  "misc-man",
  "misc-man-woman",
  "misc-megaphone",
  "misc-money",
  "misc-money-coin",
  "misc-money-paper",
  "misc-pizza",
  "misc-prayer-room",
  "misc-projector",
  "misc-puzzle",
  "misc-sparkle",
  "misc-ticket",
  "misc-traffic-cone",
  "misc-wheelchair",
  "misc-woman",
  "shapes-arrow-left-right",
  "shapes-arrow-up-down",
  // normalization shape-diamond -> shapes-diamond
  // "shapes-diamond",
  // "shapes-diamond-off",
  "social-account-add",
  "social-account-check",
  "social-account-more",
  "social-account-remove",
  "social-baby",
  "social-chat-new",
  "social-chatbot",
  "social-identification",
  "social-license",
  "view-3-square-plus",
  "view-4-square",
  "view-carousel-horizontal",
  "view-carousel-vertical",
  "view-pill-bar-stack",
  "view-rectangle-group",
  "view-stack-horizontal"
], o = "2.2.2", i = "assets/icons", t = "brand-assets.cne.ngc.nvidia.com", p = (e, a) => `https://${t}/${i}/${o}/${a}/${e}.svg`;
export {
  r as IconNames,
  d as IconTagMap,
  l as IconTags,
  m as NewIcons,
  c as getCategory,
  n as getName,
  p as iconNameToURL,
  s as isIconName
};
